module.exports = __webpack_public_path__ + "static/hero-landing-validate-7a39f559c826fb7574bdbeb4b7acfa45.png";